<template>
  <div>
    <section class="relative bg-beige-50">
      <div
        class="pointer-events-none absolute -left-3/4 h-[400px] w-[400px]
              rotate-45 rounded-[100px] bg-beige-100 sm:-top-28
              sm:h-[800px] sm:w-[800px]
              md:-left-1/2 md:bottom-auto md:h-[1200px] md:w-[1200px]
              lg:rounded-[200px]
              xl:-inset-y-1/2 xl:h-[1500px] xl:w-[1500px]"
      />
      <div class="relative">
        <div class="container ">
          <ButtonsBack
            :to="{name: 'index'}"
            type="dark"
          />
          <div class="pb-40 pt-16 lg:pt-32">
            <div class="mx-auto flex max-w-4xl flex-col items-center space-y-8 text-center">
              <h1>
                {{ page.title }}
              </h1>
              <div class="prose prose-xl" v-html="page.template.text"/>
              <UiLinkNavigation :to="{name: 'contact'}">
                Plan een kennismaking
              </UiLinkNavigation>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="relative rounded-t-large bg-white pt-11 md:rounded-t-[120px] lg:rounded-t-[160px] xl:rounded-t-[200px]">
      <div class="container">
        <div class="flex flex-col flex-wrap items-center justify-center gap-4 lg:flex-row lg:gap-10 ">
          <template v-if="sectors">
            <h3 class="as-h4">
              Onze expertises
            </h3>
            <ul class="flex flex-wrap justify-center gap-2">
              <li
                v-for="sector in sectors"
                :key="sector?.id"
              >
                <UiTag
                  :to="sector?.slug"
                  type="outline"
                  class="hover:bg-neutral-900 hover:text-white"
                >
                  {{ sector?.title }}
                </UiTag>
              </li>
            </ul>
          </template>
          <img
            src="~/assets/img/image-overons-rechts.png"
            class="aspect-video max-h-[576px] w-full max-w-5xl rounded-2xl object-cover"
          >
          <div class="mx-auto flex max-w-5xl flex-col pb-10 lg:pb-16 lg:pt-24">
            <h3 class="mb-4">
              Wat je van ons kan verwachten
            </h3>
            <p class="text-lg leading-loose">
              Bij Next Recruitment is ons streven niet alleen gericht op het vinden van de juiste mensen voor uw organisatie, maar ook op het bijdragen aan uw groei en langetermijnsucces. Naast het koppelen van talent aan vacatures, streven wij ernaar om extra waarde te bieden aan onze opdrachtgevers. Wij verdiepen ons in uw bedrijf, wat uw plannen zijn en wat voor kandidaat hier het beste bij past.
            </p>
          </div>
        </div>
        <div>
          <SectionCardGrid>
            <UiIconCard
              title="Maatwerk"
              icon="maatwerk"
              text="We gaan verder dan alleen het analyseren van CV's. We investeren tijd om uw bedrijf te leren kennen, zodat we precies begrijpen wie u nodig heeft."
            />
            <UiIconCard
              title="Talentpool"
              icon="talentpool"
              text="Toegang tot een breed netwerk van goede kandidaten in verschillende vakgebieden."
            />
            <UiIconCard
              title="Resultaten"
              icon="resultaten"
              text="Maak kennis met kandidaten die niet alleen de juiste vaardigheden hebben, maar ook naadloos aansluiten bij de cultuur van uw bedrijf."
            />
            <UiIconCard
              title="Efficiëntie"
              icon="efficientie"
              text="Optimaliseer uw tijd en middelen door gebruik te maken van onze deskundige wervingsdiensten."
            />
          </SectionCardGrid>
        </div>
        <div>
          <div class="mx-auto flex max-w-5xl flex-col px-6 py-10 lg:py-32">
            <h3 class="mb-4">
              Onze aanpak
            </h3>
            <p class="text-lg leading-loose">
              Onze aanpak richt zich niet alleen op het verbinden van kandidaten met vacatures, maar ook op het opbouwen van lange termijn waarden voor uw organisatie. We streven naar het ontwikkelen van duurzame partnerschappen en het voortdurend verbeteren van onze diensten om aan uw steeds veranderende behoeften te voldoen.
            </p>
            <p class="text-lg leading-loose">
              Met een focus op efficiëntie, expertise en betrokkenheid staan we klaar om u te ondersteunen bij groei en succes. Als uw partner in werving en selectie nemen we uw succes serieus en kijken we ernaar uit om samen met u een succesvolle toekomst op te bouwen.
            </p>
          </div>
        </div>
        <div>
          <div class="grid grid-cols-12 gap-6 pb-24 lg:grid-cols-12 lg:gap-8 lg:pb-32 xl:gap-10">
            <div class="col-span-12 lg:col-span-8">
              <div class="space-y-6 rounded-2xl bg-beige-50 p-10">
                <h3>
                  Samenwerken, neem vandaag nog contact op
                </h3>
                <p>Let’s meet. Wil je graag meer weten over onze dienstverlening? Of ben je benieuwd wat Next Recruitment voor jou kan betekenen?</p>
                <SofieForm :form-id="1" />
              </div>
            </div>
            <div class="col-span-12 flex flex-row gap-6 max-sm:flex-col lg:col-span-4 lg:flex-col lg:gap-8 xl:gap-10">
              <div class="flex flex-col items-stretch justify-between gap-2 rounded-2xl bg-beige-50 p-5 xl:p-10">
                <UiButton
                  type="secondary"
                  icon="mdi:phone-outline"
                  class="w-full"
                  label="0318-261133"
                  to="tel:0318261133"
                />
                <UiButton
                  type="secondary"
                  icon="mdi:email-outline"
                  class="w-full"
                  label="info@nextrecruitment.nl"
                  to="mailto:info@nextrecruitment.nl"
                />
              </div>
              <div class="grow">
                <img
                  src="~/assets/img/image-overons-rechts.png"
                  class="h-full w-full rounded-2xl object-cover"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import {useSectorQuery} from '~/graphql/graphql';

definePageMeta({
  middleware: ['sofie-page'],
});

const page = useSofiePage();

const {result} = useSectorQuery();
const sectors = computed(() => result.value?.sector ?? []);
</script>
